/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Payment_Failed_HintInputs */



/**
* | output |
* | --- |
* | "Payment failed — only oneAI Standard (free) is available" |
*
* @param {Chat_Payment_Failed_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_payment_failed_hint = /** @type {((inputs?: Chat_Payment_Failed_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Payment_Failed_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlung fehlgeschlagen — nur oneAI Standard (kostenlos) ist verfügbar")
	return /** @type {LocalizedString} */ ("Payment failed — only oneAI Standard (free) is available")
});